function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imagestyle/imagestylecommand
 */
import { Command } from 'ckeditor5/src/core';
/**
 * The image style command. It is used to apply {@link module:image/imagestyle~ImageStyleConfig#options image style option}
 * to a selected image.
 *
 * **Note**: Executing this command may change the image model element if the desired style requires an image of a different
 * type. See {@link module:image/imagestyle/imagestylecommand~ImageStyleCommand#execute} to learn more.
 *
 * @extends module:core/command~Command
 */

var ImageStyleCommand = /*#__PURE__*/function (_Command) {
  _inherits(ImageStyleCommand, _Command);

  var _super = _createSuper(ImageStyleCommand);

  /**
   * Creates an instance of the image style command. When executed, the command applies one of
   * {@link module:image/imagestyle~ImageStyleConfig#options style options} to the currently selected image.
   *
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   * @param {Array.<module:image/imagestyle~ImageStyleOptionDefinition>} styles
   * The style options that this command supports.
   */
  function ImageStyleCommand(editor, styles) {
    var _this;

    _classCallCheck(this, ImageStyleCommand);

    _this = _super.call(this, editor);
    /**
     * An object containing names of default style options for the inline and block images.
     * If there is no default style option for the given image type in the configuration,
     * the name will be `false`.
     *
     * @private
     * @type {Object.<String,module:image/imagestyle~ImageStyleOptionDefinition#name>}
     */

    _this._defaultStyles = {
      imageBlock: false,
      imageInline: false
    };
    /**
     * The styles handled by this command.
     *
     * @private
     * @type {module:image/imagestyle~ImageStyleConfig#options}
     */

    _this._styles = new Map(styles.map(function (style) {
      if (style.isDefault) {
        var _iterator = _createForOfIteratorHelper(style.modelElements),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var modelElementName = _step.value;
            _this._defaultStyles[modelElementName] = style.name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return [style.name, style];
    }));
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageStyleCommand, [{
    key: "refresh",
    value: function refresh() {
      var editor = this.editor;
      var imageUtils = editor.plugins.get('ImageUtils');
      var element = imageUtils.getClosestSelectedImageElement(this.editor.model.document.selection);
      this.isEnabled = !!element;

      if (!this.isEnabled) {
        this.value = false;
      } else if (element.hasAttribute('imageStyle')) {
        this.value = element.getAttribute('imageStyle');
      } else {
        this.value = this._defaultStyles[element.name];
      }
    }
    /**
     * Executes the command and applies the style to the currently selected image:
     *
     *		editor.execute( 'imageStyle', { value: 'side' } );
     *
     * **Note**: Executing this command may change the image model element if the desired style requires an image
     * of a different type. Learn more about {@link module:image/imagestyle~ImageStyleOptionDefinition#modelElements model element}
     * configuration for the style option.
     *
     * @param {Object} options
     * @param {module:image/imagestyle~ImageStyleOptionDefinition#name} options.value The name of the style (as configured in
     * {@link module:image/imagestyle~ImageStyleConfig#options}).
     * @fires execute
     */

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var editor = this.editor;
      var model = editor.model;
      var imageUtils = editor.plugins.get('ImageUtils');
      model.change(function (writer) {
        var requestedStyle = options.value;
        var imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection); // Change the image type if a style requires it.

        if (requestedStyle && _this2.shouldConvertImageType(requestedStyle, imageElement)) {
          _this2.editor.execute(imageUtils.isBlockImage(imageElement) ? 'imageTypeInline' : 'imageTypeBlock'); // Update the imageElement to the newly created image.


          imageElement = imageUtils.getClosestSelectedImageElement(model.document.selection);
        } // Default style means that there is no `imageStyle` attribute in the model.
        // https://github.com/ckeditor/ckeditor5-image/issues/147


        if (!requestedStyle || _this2._styles.get(requestedStyle).isDefault) {
          writer.removeAttribute('imageStyle', imageElement);
        } else {
          writer.setAttribute('imageStyle', requestedStyle, imageElement);
        }
      });
    }
    /**
     * Returns `true` if requested style change would trigger the image type change.
     *
     * @param {module:image/imagestyle~ImageStyleOptionDefinition} requestedStyle The name of the style (as configured in
     * {@link module:image/imagestyle~ImageStyleConfig#options}).
     * @param {module:engine/model/element~Element} imageElement The image model element.
     * @returns {Boolean}
     */

  }, {
    key: "shouldConvertImageType",
    value: function shouldConvertImageType(requestedStyle, imageElement) {
      var supportedTypes = this._styles.get(requestedStyle).modelElements;

      return !supportedTypes.includes(imageElement.name);
    }
  }]);

  return ImageStyleCommand;
}(Command);

export { ImageStyleCommand as default };